import getInstanceAxios from './RequestGlobalConfig';

export default getInstanceAxios(process.env.REACT_APP_CHECKOUT_WEB_V2);
